import React from 'react';
import immutable from 'immutable';
import UserAvatar from 'components/pure/utils/UserAvatar';
import {metadataLineOne, metadataLineTwo, metadataLineThree} from 'components/metadataLine';

require('styles/Metadata.styl');

const classNames = require('classnames');

/**
 * <FileUploadMetadata /> renders the basic metadata of a file upload object including
 * caller avatar, caller name, title, outcome and duration and date. Notice that this component
 * could be reusable across multiple parent components
 */
class FileUploadMetadata extends React.Component {
  /** Return the fullname of `this.props.fileUpload.caller` */
  callerName() {
    const fileUpload = this.props.fileUpload;
    return fileUpload.caller.first_name + ' ' + fileUpload.caller.last_name;
  }

  /**
   * Return the metadata line one for `this.props.fileUpload`
   * @return {string}
   */
  lineOne() {
    return metadataLineOne(this.props.fileUpload['custom_content']);
  }

  /**
   * Return the metadata line two for `this.props.fileUpload`
   * @return {string}
   */
  lineTwo() {
    return metadataLineTwo(this.props.fileUpload['custom_content']);
  }

  /**
   * Return the metadata line three `this.props.fileUpload`
   * @return {string}
   */
  lineThree() {
    return metadataLineThree(this.props.fileUpload['custom_content']);
  }

  render() {
    const caller = this.props.fileUpload.caller;
    let style = immutable.Map({});
    style = style.merge(this.props.style);
    const className = classNames('metadata', this.props.className);

    return (
      <div className={className} style={style.toObject()}>
        <div className="left">
          <UserAvatar user={caller} enableTooltip={true} tooltipDirection="top" />
          {(() => {
            if (this.props.shouldRenderUsername) {
              return <div className="username">{this.callerName()}</div>;
            }
          })()}
        </div>
        <div className="center">
          <div className="title" dangerouslySetInnerHTML={{__html: this.lineOne()}} />
          <div className="outcome" dangerouslySetInnerHTML={{__html: this.lineTwo()}} />
          <div className="date" dangerouslySetInnerHTML={{__html: this.lineThree()}} />
        </div>
      </div>
    );
  }
}

export default FileUploadMetadata;
